import { createContext } from 'react';

import { LocationInterface, DefaultInterface } from '../../models/services/location-interface';

const LocationContext = createContext<LocationInterface>(DefaultInterface);

export { LocationContext };